import { gql } from "@apollo/client";

const STUDENT_REGISTRATION_WITH_OAUTH = gql`
  mutation StudentRegistrationWithOauth(
    $currentLevelId: ID!
    $sendTips: Boolean
    $spokenOnly: Boolean
    $locale: String
    $charactersPreference: String
    $timeZone: String
    $token: String
    $adInfo: String
    $urlRegister: String
    $registrationSurveyId: ID
    $role: Int
  ) {
    studentRegistrationWithOauth(
      currentLevelId: $currentLevelId
      sendTips: $sendTips
      spokenOnly: $spokenOnly
      locale: $locale
      charactersPreference: $charactersPreference
      timeZone: $timeZone
      token: $token
      adInfo: $adInfo
      urlRegister: $urlRegister
      registrationSurveyId: $registrationSurveyId
      role: $role
    ) {
      credentials {
        uid
        accessToken
        client
      }
      authenticatable {
        givenName
        familyName
        locale
        email
      }
    }
  }
`;

export default STUDENT_REGISTRATION_WITH_OAUTH;
